import styled from "styled-components";

export const Header = styled.header`
    width: 100%;
    background-color: var(--bg-color);
`;
